import { mapGetters } from 'vuex';

/**
 * Encapsulates FeatureSwitch visibility check
 * Usage:
 * 1. Add mixin to the component
 * 2. populate the "displayOnActiveFeatureSwitches" properties with the target feature switch(es)
 * 3. Use computed property "isVisibleOnFeatureSwitch" to determine visibility
 */
export default {
	computed: {
		...mapGetters('principal', [
			'enabledFeatureSwitches',
			'hasFeatureSwitch'
		]),
		isFeatureSwitchEnabled() {
			return this.hasFeatureSwitch(this.displayOnActiveFeatureSwitches);
		},
		isVisibleOnFeatureSwitch() {
			const isFeatureSwitchPropUsed = Array.isArray(
				this.displayOnActiveFeatureSwitches
			)
				? this.displayOnActiveFeatureSwitches.length > 0
				: this.displayOnActiveFeatureSwitches > 0;

			return isFeatureSwitchPropUsed ? this.isFeatureSwitchEnabled : true;
		}
	},
	props: {
		displayOnActiveFeatureSwitches: {
			type: [Array, Number],
			default: () => []
		}
	},
	methods: {
		isFeatureSwitchActive(featureSwitchId) {
			return this.hasFeatureSwitch(featureSwitchId);
		},
		checkFeatureSwitches(featureSwitches) {
			return this.hasFeatureSwitch(featureSwitches);
		}
	}
};
